export default [
    // *===================Job Card List============================---*

    {
        path: '/jobcard/list',
        name: 'jobcard-list',
        component: () => import('@/views/production/jobcard/jobcard-list/JobCardList.vue'),
        meta: {
            pageTitle: 'Job Cards List',
            breadcrumb: [
                {
                    text: 'Job Cards List',
                    active: true,
                },
            ],
            permission: 'Permissions.Production.View'            
        },
    },

    // *===================Job Card List============================---*

    {
        path: '/jobcard/list/:status',
        name: 'jobcard-list-status',
        component: () => import('@/views/production/jobcard/jobcard-list/JobCardList.vue'),
        meta: {
            pageTitle: 'Job Cards List',
            breadcrumb: [
                {
                    text: 'Job Cards List',
                    active: true,
                },
            ],
            permission: 'Permissions.Production.View'            
        },
    },



    // *===================Job Card Add============================---*
    {
        path: '/jobcard/add/:id',
        name: 'jobcard-add-product',
        component: () => import('@/views/production/jobcard/jobcard-add/JobcardAddProduct.vue'),
        meta: {
            pageTitle: 'Add Job Card',
            breadcrumb: [
                {
                    text: 'Low Stock Refill List',
                    to: '/lowstock/list',
                },
                {
                    text: 'Add Job Card',
                    active: true,
                },
            ],
            permission: 'Permissions.Production.View'  
        },
    },


        // *===================Job Card Add============================---*
        {
            path: '/jobcard/add',
            name: 'jobcard-add',
            component: () => import('@/views/production/jobcard/jobcard-add/JobcardAdd.vue'),
            meta: {
                pageTitle: 'Add Job Card',
                breadcrumb: [
                    {
                        text: 'Job Cards List',
                        to: '/jobcard/list',
                    },
                    {
                        text: 'Add Job Card',
                        active: true,
                    },
                ],
                permission: 'Permissions.Production.View'  
            },
        },
    
    




    // *===================Job Card View============================---*
    {
        path: '/jobcard/view/:id',
        name: 'jobcard-view',
        component: () => import('@/views/production/jobcard/jobcard-view/jobcardview.vue'),
        meta: {
            pageTitle: 'View Job Card',
            breadcrumb: [
                {
                    text: 'Job Cards List',
                    to: '/jobcard/list',
                },
                {
                    text: 'View Job Card',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/jobcardtimesheet/list',
        name: 'jobcardtimesheet-list',
        component: () => import('@/views/production/timesheet/Timesheet.vue'),
        meta: {
            pageTitle: 'Timesheet',
            breadcrumb: [
                {
                    text: 'Timesheet List',
                    active: true,
                },
            ],
            permission: 'Permissions.Production.View'
        },
    },
    {
        path: '/jobcardtimesheet/add',
        name: 'JobCardtimesheet-add',
        component: () => import('@/views/production/timesheet/Add.vue'),
        meta: {
            pageTitle: 'Add Timesheet',
            breadcrumb: [
                {
                    text: 'Timesheet List',
                    to: '/jobcardtimesheet/list',
                },
                {
                    text: 'Add Timesheet',
                    active: true
                },
            ],
            type: "add",
            permission: 'Permissions.Production.View'
        },
    },
    {
           path: "/jobcardtimesheet/add/:id/:jobcardId",
           name: 'JobCardtimesheet-add',
           component: () => import('@/views/production/timesheet/Add.vue'),
           meta: {
               pageTitle: 'Add Timesheet',
               breadcrumb: [
                   {
                       text: 'Timesheet List',
                       to: '/jobcardtimesheet/list',
                   },
                   {
                       text: 'Add Timesheet',
                       active: true
                   },
               ],
               type: "add",
               permission: 'Permissions.Production.View'
           },
    },
    {
        path: '/jobcardtimesheet/edit/:id',
        name: 'jobcardtimesheet-edit',
        component: () => import('@/views/production/timesheet/Add.vue'),
        meta: {
            pageTitle: 'Edit Timesheet',
            breadcrumb: [
                {
                    text: 'Timesheet List',
                    to: '/jobcardtimesheet/list',
                },
                {
                    text: 'Edit Timesheet',
                    active: true
                },
            ],
            type: "edit",
            permission: 'Permissions.Production.View'
        },
    },
    {
        path: '/jobcardtimesheet/view/:id',
        name: 'jobcardtimesheet-view',
        component: () => import('@/views/production/timesheet/Add.vue'),
        meta: {
            pageTitle: 'View Timesheet',
            breadcrumb: [
                {
                    text: 'Timesheet List',
                    to: '/jobcardtimesheet/list',
                },
                {
                    text: 'View Timesheet',
                    active: true
                },
            ],
            type: "view",
            permission: 'Permissions.Production.View'
        },
    },
]